var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"max-w-5xl m-5 max-h-full mb-10 w-full"},[_c('app-synthesis-observation',{attrs:{"observation-id":this.$route.params.observationId},on:{"deleted":function($event){return _vm.backToList()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }